module.exports = __webpack_public_path__ + "img/loja-online-verde.29295792.png";